export const sanitizeFileName = (fileName) => (fileName || 'download').replace(/[\r\n]+/g, ' ').trim() || 'download';

/**
 * Starts a file download from a presigned S3 URL without fetch/CORS.
 * Uses a hidden iframe (same effect as opening the URL in the browser).
 */
export const autoDownloadPresignedUrl = (url) => {
  if (!url) {
    return false;
  }

  try {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('aria-hidden', 'true');
    iframe.title = 'download';
    iframe.style.cssText = 'display:none;width:0;height:0;border:0;position:absolute';
    iframe.src = url;
    document.body.appendChild(iframe);

    setTimeout(() => {
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    }, 120000);

    return true;
  } catch (error) {
    console.error('Auto download failed:', error);
    return false;
  }
};
